import { render, staticRenderFns } from "./widget-activities.vue?vue&type=template&id=48a65fc2&scoped=true"
import script from "./widget-activities.vue?vue&type=script&lang=js"
export * from "./widget-activities.vue?vue&type=script&lang=js"
import style0 from "./widget-activities.vue?vue&type=style&index=0&id=48a65fc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a65fc2",
  null
  
)

export default component.exports